<template>
  <div>
    <!-- <statistic-card-horizontal icon="book" statistic-title=""
    style="max-width:300px"
    /> -->
    <!-- <div
    class="form center m-5 vx-col w-3/12"
    @click="$router.push('/forms/pre-arrival-form')" >
      <feather-icon class="mr-1" icon="InfoIcon" />
      <h1>Pre Arrival Concierge Form</h1>
    </div>
    <div
    class="form center m-5 vx-col w-3/12"
    @click="$router.push('/forms/guest-feedback')">
      <feather-icon class="mr-1" icon="InfoIcon" />
      <h1>Guest Feedback</h1>
    </div>
    <div
    class="form center m-5 vx-col w-3/12"
    @click="$router.push('/forms/pre-arrival-checklist-form')">
      <feather-icon class="mr-1" icon="InfoIcon" />
      <h1>Pre Arrival Checklist</h1>
    </div> -->
    <vs-row
  vs-align="flex-start"
  vs-type="flex" vs-justify="center" vs-w="12">
  <vs-col vs-w="3">
    <vs-card class="cardx">
    <div class="center" @click="$router.push('/forms/pre-arrival-form')" >
      <feather-icon class="splicon" icon="EditIcon" />
      <h1 class="title">Pre Arrival <span>Concierge Form</span></h1>
    </div>
    </vs-card>
  </vs-col>
  <vs-col vs-w="3">
    <vs-card class="cardx">
    <div class="center"
    @click="$router.push('/forms/guest-feedback')">
      <feather-icon class="splicon" icon="EditIcon" />
      <h1 class="title">Guest <span>Feedback</span></h1>
    </div>
    </vs-card>
  </vs-col>
  <vs-col vs-w="3">
    <vs-card class="cardx">
    <div class="center" @click="$router.push('/forms/pre-arrival-checklist-form')">
      <feather-icon class="splicon" icon="EditIcon" />
      <h1 class="title">Pre Arrival <span>Checklist</span></h1>
    </div>
    </vs-card>
  </vs-col>
  <vs-col vs-w="3">
    <vs-card class="cardx">
    <div class="center" @click="$router.push('/forms/lead-form')">
      <feather-icon class="splicon" icon="EditIcon" />
      <h1 class="title">Lead<span>Form</span></h1>
    </div>
    </vs-card>
  </vs-col>
</vs-row>
  </div>

</template>

<script>
// import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'

export default {
  components: {
    // StatisticCardHorizontal
  }
}
</script>

<style scoped>

.router-header{
justify-content: center;
}
.cardx {
    width: calc(100% - 20px);
    margin: 10px;
    margin-bottom: 20px;
    cursor: pointer;
}
.cardx .title{
  font-size: 20px;
}
.cardx .title span{
  display: block;
}
.cardx .feather-icon.splicon{
margin: 20px 0 30px;
}
.cardx .feather-icon .feather{
  width: 40px;
  height: 40px;
}

  .center{
    text-align: center;
  }

</style>
